import React, { useEffect } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Navbar from "../component/Navbar";
import { URL, colors } from "../utils/constant";
import { useNavigate } from "react-router-dom";
import VisitNavbar from "../component/VisitNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getUserLoggedInStatus } from "../data/selector/auth.selector";
import { useAuth } from "../data/talons/auth/useAuth";
import useInstruction from "../data/talons/Instruction/useInstruction";
import Header from "../component/Header";
// import useGlobalPageLoader from "../data/talons/loader/useFullPageLoader";
import GlobalPageLoader from "../data/talons/loader/useFullPageLoader";
import {
  getLanguage,
  getLanguageNumber,
} from "../data/selector/language.selector";
import { getUserToken } from "../data/selector/appState.selector";
import { setSelectedLanguage } from "../data/reducer/language.reducer";
import { English } from "../Languages/en";
import { Spanish } from "../Languages/sp";
import { size } from "lodash";

export default function Instruction() {
  // const { autoLogout } = useAuth();
  // const { inactivityTimeout, handleMouseMove, isActive } = autoLogout();
  const navigate = useNavigate();
  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);
  const dispatch = useDispatch();
  const { fetchInstruction, Instructions } = useInstruction();

  useEffect(() => {
    // console.log(dropdownValue, "vkvkvkv");
    if (!number) {
      // console.log("noneWnglish");
      dispatch(setSelectedLanguage(English));
      fetchInstruction();
    } else if (number == 1) {
      dispatch(setSelectedLanguage(English));
      fetchInstruction();
    } else if (number == 2) {
      dispatch(setSelectedLanguage(Spanish));
      fetchInstruction();
    }
    // dispatch(setSelectedLanguage(Spanish));
    // console.log("nnnn");
  }, [number]);
  const token = useSelector(getUserToken);
  useEffect(() => {
    if (size(token) === 0) {
      navigate(URL.login);
    }
  }, [token]);
  return (
    <>
      {GlobalPageLoader()}
      <VisitNavbar />
      <Grid>
        <Header />
        <Grid
          // position={"fixed"}
          sx={{ pt: 7 }}
          className="px-5"
          style={{
            marginLeft: "3rem",
            backgroundColor: "whitesmoke",
            height: "100vh",
          }}
        >
          <Typography variant="h4" className="mt-3">
            {Language.InstructionTitle.instruction_head}
          </Typography>

          <Grid sx={{ backgroundColor: "white" }}>
            <Grid
              className="px-4 py-3"
              dangerouslySetInnerHTML={{ __html: Instructions?.Instructions }}
            />
            <Grid
              container
              justifyContent={"center"}
              alignItems={"flex-end"}
              sx={{ backgroundColor: "white" }}
            >
              <Box sx={{ flex: "end" }} width={"40%"}>
                <Button
                  fullWidth
                  type="button"
                  variant="contained"
                  sx={{
                    backgroundColor: colors.blue,
                    "&:hover": {
                      backgroundColor: colors.blue,
                    },
                    mb: 2,
                  }}
                  onClick={() => navigate(URL.visit)}
                >
                  {Language.LoginTitle.proceed_btnText}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
